import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReplicationDialogComponent } from '../replication-dialog/replication-dialog.component';

@Component({
  selector: 'lib-replication-search',
  templateUrl: './replication-search.component.html',
  styleUrls: ['./replication-search.component.scss'],
})
export class ReplicationSearchComponent {

  recordsTotal: number = 0;
  flagSearch: boolean = false;

  headArray: any = [
    {
      Head: 'Proceso',
      FieldName: 'nombre',
    },
    {
      Head: 'Descripción',
      FieldName: 'descripcion',
      Tooltip: true,
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'view', icon: 'open_in_new', toolTip: 'Detalle' },
      ],
      width: '8',
      permanent: true,
    },
  ];

  // TODO: sustituir por el listado de procesos de réplica obtenido del backend cuando esté disponible en api-rest.
  gridArray: any[] = [
    {
      id: 'REGISTRO_PRODUCTORES_PRODUCTO_POSEEDORES',
      nombre: 'Registro de Productores de Producto de Poseedores',
      descripcion: 'Replica el Registro de Productores de Producto de los poseedores de un año al siguiente.',
    },
  ];

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
    this.cargarProcesos();
  }

  cargarProcesos() {
    this.recordsTotal = this.gridArray.length;
    this.flagSearch = this.gridArray.length > 0;
  }

  action(item: any) {
    if (item.nameButton == 'view') {
      this.abrirModalDetalle(item);
    }
  }

  abrirModalDetalle(proceso: any): void {
    this.dialog.open(ReplicationDialogComponent, {
      width: '600px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        proceso: proceso,
      },
      disableClose: true,
    });
  }
}
